export default __webpack_public_path__ + "static/media/citsec.fa7d3115.jpg";